import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';

export function useActivity(projectId = null) {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchActivities = useCallback(async () => {
    setLoading(true);
    try {
      let url = '/projects/activities/'; 
      if (projectId) {
          url = `/projects/${projectId}/history/`;
      }
      
      const response = await api.get(url);
      setActivities(response.data);
      setError(null);
    } catch (err) {
      console.error("Failed to fetch activities:", err);
      setError(err.response?.data?.detail || "Failed to load activities");
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    fetchActivities();
  }, [fetchActivities]);

  return {
    activities,
    loading,
    error,
    refreshActivities: fetchActivities
  };
}
